import { Box } from "@mui/material";
import CalcOption from "./CalcOption";
import { HeaderOptions } from "../../../../types/budget/budget";

type Props = {
  value: HeaderOptions;
  onChange: (type: HeaderOptions) => void;
};

export default function LeftSideBarHeader({ value, onChange }: Props) {
  const optionsArr: HeaderOptions[] = ["A", "B", "C", "D", "budgetTotals"];
  const optionsDescription: string[] = [
    "Pagamento direto pelo cliente (Cartão de Crédito, EBTA ou PO direta)",
    "Nota de débito (faturados contra o cliente por meio de Nota de Débito MM)",
    "Custos de terceiros (faturados contra a MM e cobrados do cliente em Nota Fiscal MM)",
    "Custos internos (cobrados do cliente em Nota Fiscal MM – sem honorários)",
    "Totais",
  ];

  return (
    <Box display="flex" flexDirection={"column"}>
      {optionsArr.map((el, index) => (
        <CalcOption
          key={el}
          type={el}
          isActive={value === el}
          setIsActive={onChange}
          description={optionsDescription[index]}
        />
      ))}
    </Box>
  );
}
